import showcaseImg from '@assets/images/About/showcase.png';

export default function AboutShowcase() {
  return (
    <section className="w-full overflow-hidden">
      <div
        data-aos="fade-up"
        role="img"
        aria-label="AeroComp showcase"
        className="
          relative mx-auto min-h-[40vh] w-full
          max-w-[1600px] overflow-hidden
          bg-cover bg-center bg-no-repeat
          sm:min-h-[50vh] md:h-[55vh] md:bg-fixed lg:h-[60vh] xl:h-[55vh]
        "
        style={{
          backgroundImage: `url(${showcaseImg})`,
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/20" />
      </div>
    </section>
  );
}
